export const EMAIL_FIELD = 'login';
export const PASSWORD_FIELD = 'password';
